const project_card = [
  {
    id: 1,
    project_name: "Personal Card",
    technologies: "HTML & CSS",
    animation_effect: "zoom-in-left",
    project_link: "https://niv-htmlcss.netlify.app/",
    thumb: require("../images/portfolio/proj1.png"),
  },
  {
    id: 2,
    project_name: "Swappi",
    technologies: "ReactJS",
    animation_effect: "zoom-in-left",
    project_link: "https://swappi-ai.com/",
    thumb: require("../images/portfolio/proj3.png"),
  },
  {
    id: 3,
    project_name: "Comfy Shop",
    technologies: "ReactJS",
    animation_effect: "zoom-in-right",
    project_link: "https://niv-comf-shop.netlify.app/",
    thumb: require("../images/portfolio/proj2.png"),
  },
  {
    id: 4,
    project_name: "Shabtzak",
    technologies: "ReactJS",
    animation_effect: "zoom-in-right",
    project_link: "https://shabtsak.top",
    thumb: require("../images/portfolio/proj4.png"),
  },
  {
    id: 5,
    project_name: "Personal Card",
    technologies: "TypeScript & Scss",
    animation_effect: "zoom-in-left",
    project_link: "https://nimni-hovalot.co.il/",
    thumb: require("../images/portfolio/proj5.png"),
  },
  {
    id: 6,
    project_name: "Cocktail Party",
    technologies: "ReactJS",
    animation_effect: "zoom-in-right",
    project_link: "https://cocktails-party.netlify.app/",
    thumb: require("../images/portfolio/proj6.png"),
  },
];
export default project_card;
